import moment from "moment-timezone";

const LORE_REVEAL_TIMESTAMP = moment
  .tz("2026-09-18T22:00:00", "America/Toronto")
  .valueOf();

const SECRET_LORE_TERM_PATTERN = /\bthe fade\b|\bfade\b|\bluma\b/gi;

export const redactLoreTerms = (text: string, now: Date) =>
  now.getTime() < LORE_REVEAL_TIMESTAMP
    ? text.replace(SECRET_LORE_TERM_PATTERN, (term) => "█".repeat(term.length))
    : text;
